import { api } from '@@/services//api';

export const postApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchPost: builder.query<Alacaza.Post, string>({
      query: (postId) => `/partners/posts/${postId}`,
      providesTags: ['Posts'],
    }),
  }),
});

export const { useFetchPostQuery } = postApi;
